import React from "react";

const PieChart = ({
  onClickFn = () => {},
  width = "23",
  height = "21",
  fill = "currentColor",
}) => {
  return (
    <svg
      className="cursor-pointer"
      onClick={onClickFn}
      width={width}
      height={height}
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* <path d="M18 16H0V0H18V16Z" stroke="#E5E7EB"/> */}
      <path d="M9.5 7.5V0.51875C9.5 0.2375 9.71875 0 10 0C13.8656 0 17 3.13438 17 7C17 7.28125 16.7625 7.5 16.4813 7.5H9.5ZM1 8.5C1 4.70937 3.81562 1.57187 7.46875 1.07187C7.75625 1.03125 8 1.2625 8 1.55313V9L12.8906 13.8906C13.1 14.1 13.0844 14.4438 12.8438 14.6125C11.6187 15.4875 10.1187 16 8.5 16C4.35938 16 1 12.6438 1 8.5ZM17.45 9C17.7406 9 17.9688 9.24375 17.9312 9.53125C17.6906 11.2781 16.85 12.8312 15.6219 13.9781C15.4344 14.1531 15.1406 14.1406 14.9594 13.9563L10 9H17.45Z" fill={"none"} stroke="#fff"/>
    </svg>
  );
};

export default PieChart;